// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13294(2c3fc60439)-C03/11/2026-15:49:17-B03/11/2026-15:57:39' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13294(2c3fc60439)-C03/11/2026-15:49:17-B03/11/2026-15:57:39",
  branch: "test",
  latestTag: "8.1",
  revCount: "13294",
  shortHash: "2c3fc60439",
  longHash: "2c3fc6043969f162497a36c8614e27df15232206",
  dateCommit: "03/11/2026-15:49:17",
  dateBuild: "03/11/2026-15:57:39",
  buildType: "Ansible",
  } ;
